// extracted by mini-css-extract-plugin
module.exports = {"hero-content":"hero_hero-content__zV_il","hero":"hero_hero__s940E","hero-bg":"hero_hero-bg__S4_7j"};